import Repository from './Repository';
import TokenService from '../helpers/token';

const resource = `${Repository.defaults.baseURL}/contact`;

export default {

  async list(params) {
    const response = await Repository.get(`${resource}/partner`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },

  async listStatus(params) {
    const response = await Repository.get(`${resource}/partner/status`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async listHistory(params) {
    const response = await Repository.get(`${resource}/history`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },

  async detailHistory(id) {
    const response = await Repository.get(`${resource}/history/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getTransactionHistory(id) {
    const response = await Repository.get(`${resource}/history/${id}`, {
      headers: TokenService.getHeader(),
    })
    // return response
    return {
      success: true,
      data: [
        {
          pay_date: '2021-05-23',
          rose: '9000000',
          bonus: '1000000',
          fax: '0',
        },
        {
          pay_date: '2021-05-23',
          rose: '9000000',
          bonus: '1000000',
          fax: '0',
        },
        {
          pay_date: '2021-05-23',
          rose: '9000000',
          bonus: '1000000',
          fax: '0',
        }
      ],
      totalItem: 99
    }
  },

  async countTotal() {
    const response = await Repository.get(`${resource}/partner/total`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async policyCTV() {
    const response = await Repository.get(`/policy-partner`, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async applyPolicy(data) {
    const response = await Repository.post(`/policy-partner/apply`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
}
